import { render } from "./BundlesComponent.vue?vue&type=template&id=65d4ba42"
import script from "./BundlesComponent.vue?vue&type=script&lang=js"
export * from "./BundlesComponent.vue?vue&type=script&lang=js"

import "./BundlesComponent.vue?vue&type=style&index=0&id=65d4ba42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__